<template>
  <div class="loading-wrapper">
    <div class="loading-bar">
      <md-progress-bar
        class="md-primary progress-bar"
        :md-value="loadingPercentage"
      ></md-progress-bar>
    </div>
    <md-card class="loading-circle">
      <md-icon class="working"> cached </md-icon>
    </md-card>
  </div>
</template>

<script>
export default {
  computed: {
    loadingPercentage() {
      return Math.floor((1 / this.loading) * 100);
    },
  },
  data() {
    return {
      maxLoading: 0,
    };
  },
  props: ['loading'],
  watch: {
    loading (to) {
      if (to === 0) this.maxLoading = 0;
      else if (to > this.maxLoading) this.maxLoading = to;
    },
  },
};
</script>

<style scoped>
.loading-wrapper {
  z-index: 12000;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(20, 20, 20, 0);
}
.loading-bar {
  z-index: 12001;
  /* position: fixed; */
  top: 20px;
  width: 100%;
}
.progress-bar {
  /* transform: scaleY(2); */
}
.loading-circle {
  max-width: 3em;
  position: fixed;
  bottom: 0;
  right: 0;
  transform: translate(-100%, -100%);
  background: linear-gradient(
    144deg,
    rgba(185, 243, 255, 1) 0%,
    rgba(20, 177, 255, 1) 83%,
    rgba(0, 168, 255, 1) 100%
  ) !important;
}
.working {
  animation: rotate 1s linear infinite;
  color: white !important;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(-180deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>
